export { registerAxis, registerCircleAxis, registerLineAxis } from './axis';
export { registerLegend } from './legend';
export { registerSlider } from './slider';
export { registerLabel } from './label';
export { registerDataZoom } from './datazoom';
export { registerPlayer } from './player';
export { registerTitle } from './title';
export { registerGrid, registerCircleGrid, registerLineGrid } from './grid';
export { registerScrollbar } from './scrollbar';
